module.exports = __webpack_public_path__ + "media/images/action_up-476941d6083f65f506a0a8a74b4d3c40.png";